import React, { PureComponent } from 'react';
import moment from 'moment';

import { TextField, MenuItem, TableCell, TableRow, TableBody, Table } from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import Utils from '../../../../common/utils/Utils';
import InstrumentAutocomplete from '../../../../common/components/InstrumentAutocomplete/InstrumentAutocomplete';
import Loading from '../../../../common/components/Loading/Loading';
import './InstrumentSummary.css';
import Constants from '../../../../common/constants/Constants';

const constructLinkList = (links, currentPath, onChange) =>
  links.length == 0 ? null : (
    <TextField
      variant="standard"
      select={true}
      fullWidth
      onChange={(e) => onChange(e.target.value)}
      label="Navigate to"
      value={currentPath}
      data-qa="qa-instrument-navigate"
    >
      {links.map((link, index) => (
        <MenuItem key={index} value={link.path}>
          {link.name}
        </MenuItem>
      ))}
    </TextField>
  );

class InstrumentSummary extends PureComponent {
  render() {
    const { instrument, links, currentPath, onChange } = this.props;

    let localTime = Utils.FormatDateTime(
      moment()
        .utc()
        .utcOffset(instrument.UtcOffset ? instrument.UtcOffset : 0),
      this.props.globalSettings
    );
    return (
      <Tile className="instrument-summary" title="Instrument summary" helpTag="instrument_summary">
        {constructLinkList(links, currentPath, onChange)}
        <div className="u-mb-half">
          {
            <Loading condition={this.props.instruments.length === 0}>
              <InstrumentAutocomplete
                hideClearIcon={true}
                qaActionTag="change"
                instrumentList={this.props.instruments}
                currentInstrument={instrument}
                onChange={this.props.onChangeInstrumentSelection}
                disableCloseOnSelect={false}
              />
            </Loading>
          }
        </div>

        <Table data-qa="qa-instrument-summary">
          <TableBody>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>{instrument.Type ? instrument.Type : 'Not available'}</TableCell>
            </TableRow>
            {instrument.OperatingSystem ? (
              <TableRow>
                <TableCell>Operating System</TableCell>
                <TableCell>{instrument.OperatingSystem}</TableCell>
              </TableRow>
            ) : null}
            {instrument.PCModel ? (
              <TableRow>
                <TableCell>PC Model</TableCell>
                <TableCell>{instrument.PCModel}</TableCell>
              </TableRow>
            ) : null}
            {instrument.CameraVersion ? (
              <TableRow>
                <TableCell>Camera version</TableCell>
                <TableCell>{instrument.CameraVersion}</TableCell>
              </TableRow>
            ) : null}
            <TableRow>
              <TableCell>Software version</TableCell>
              <TableCell>
                {instrument.SoftwareVersion ? instrument.SoftwareVersion : 'Not available'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Local time</TableCell>
              <TableCell>{instrument.UtcOffset ? localTime : 'Not available'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Registered date</TableCell>
              <TableCell>
                {instrument.FirstRegisteredDate
                  ? Utils.FormatDateTime(
                      moment(instrument.FirstRegisteredDate),
                      this.props.globalSettings
                    )
                  : 'Not available'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Last updated</TableCell>
              <TableCell>
                {instrument.ApplicationTimeStamp
                  ? Utils.FormatDateTime(
                      moment(instrument.ApplicationTimeStamp),
                      this.props.globalSettings
                    )
                  : 'Not available'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Certificate expiration </TableCell>
              <TableCell>
                {instrument.CertificateValidTo
                  ? Utils.FormatDateTime(
                      moment(instrument.CertificateValidTo),
                      this.props.globalSettings
                    ).split(' ')[0]
                  : 'Not available'}
              </TableCell>
            </TableRow>
            {instrument.CycleCount ? (
              <TableRow>
                <TableCell>System cycle</TableCell>
                <TableCell>{instrument.CycleCount}</TableCell>
              </TableRow>
            ) : null}
            <TableRow>
              <TableCell>Uptime</TableCell>
              <TableCell>
                {instrument.LiveUptime && instrument.Connected
                  ? Utils.FormatDuration(instrument.LiveUptime, this.props.globalSettings)
                  : 'Not available'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Overall alert</TableCell>
              <TableCell>
                {instrument.OverallAlert ? instrument.OverallAlert.Name : 'Not available'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Connection</TableCell>
              <TableCell>{instrument.Connected ? 'Online' : 'Offline'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>{instrument.Status ? instrument.Status : 'Not available'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Test average</TableCell>
              <TableCell>
                {instrument.AverageTests
                  ? Utils.FormatNumber(instrument.AverageTests, this.props.globalSettings)
                  : 'Not available'}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Tile>
    );
  }
}

export default InstrumentSummary;
